export default "__VITE_ASSET__ab0a83b7__"